export default "__VITE_ASSET__BFsr4q4C__"